<template>
<div class="m-grid m-grid--hor m-grid--root m-page main-page">
    <div
      class="m-grid__item m-grid__item--fluid m-grid m-grid--desktop m-grid--ver-desktop m-grid--hor-tablet-and-mobile m-login m-login--6"
      id="m_login"
    >
      <div
        class="m-grid__item m-grid__item--fluid m-grid__item--order-tablet-and-mobile-1 m-login__wrapper"
      >
        <!--begin::Body-->
        <div class="m-login__body main-page">
          <!--begin::Signin-->
          <div class="m-login__signin">
            <div class="m-login__title">
              <h3>
                <img src="../assets/MdtImages/mdt-logo-2.png" alt />
              </h3>
              <p style="font-weight:bold">Lütfen giriş yapınız.</p>
            </div>

            <!--begin::Form-->
            <form class="m-login__form m-form row" >
              <div class="row" >
                <div class="col-md-4">
                  <div class="form-group m-form__group">
                    <input
                      class="form-control m-input log-inp"
                      style="background-color:#ebeef4"
                      v-model="model.tenantCode"
                      type="text"
                      placeholder="Kod"
                      name="code"
                      autocomplete="off"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group m-form__group">
                    <input
                      class="form-control m-input log-inp"
                      type="text"
                       style="background-color:#ebeef4"
                      v-model="model.email"
                      placeholder="Kullanıcı Adı"
                      name="email"
                      autocomplete="off"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group m-form__group">
                    <input
                      class="form-control m-input log-inp m-login__form-input--last"
                      v-model="model.password"
                      type="password"
                       style="background-color:#ebeef4"
                      placeholder="Şifre"
                      name="password"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">                 
                  <div class="m-login__action" >
                    <div  class="flex-start">
                     <input type="checkbox"
                      style="margin-left:5px;border-radius:5px; height:14px; width:20px;" id="keep-login">
                     <label style="font-size:16px;" for="keep-login">Oturumu açık tut</label>
                    </div>
                  <button
                      type="button"
                      id="m_login_signin_submit"
                      @click="login"
                      class="spbtn flex-end"
                    >Giriş Yap</button>
                  </div>
                </div>
                <PasswordRecovery v-if="isForgetPassword"></PasswordRecovery>
                <div class="row">
                <div class="col-md-12">
                  <div class="m-login__action flex-start" style="margin-top:0">
                  
                    <a @click="forgetPassword()">Şifremi Unuttum</a>
                    <span>
                      Üye değil iseniz?
                      <a href="#">
                        <span>Üye olun</span>
                      </a>
                    </span>
                  </div>
                </div>
                </div>
              </div>
            </form>

            <!--end::Form-->
          </div>

          <!--end::Signin-->
        </div>

        <!--end::Body-->
      </div>

      <div
        class="m-grid__item m-grid__item--order-tablet-and-mobile-2 m-grid m-grid--hor m-login__aside loginbg"
      >
        <div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver">
          <div class="m-grid__item m-grid__item--middle">
            <div class="m-login__title">
              <h2>MDT Cloud</h2>
Sayfasına Hoşgeldiniz {{getEnvironmetMessage()}}
            </div>
            <!-- <span class="m-login__subtitle">Felan felannn<br>
Yalan dolann<br>
            cart curt</span>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.loginbg {
  max-height: 1000px;
  background-image: url(../assets/app/media/img/bg/bg-4.jpg) !important;
}
.login-btn {
  border-radius: 18px !important;
  width: 193px;
  padding: 10px !important;
}

.input-ground {
  background-color: #ebeef4;
}

.main-page {
  background-color: #ffffff;
}

.m-body {
  background-color: #ffffff !important;
}
.m-content--skin-light2 {
  background-color: #ffffff !important;
}
</style>
<script>
import { _login, _authorize } from "../services/LoginService";
import router from "../router/index";

import PasswordRecovery from "../components/Admin/PasswordRecovery.vue";
import { AppConfiguration } from "read-appsettings-json";

export default {
  data() {
    return {
      model: {
        tenantCode: "ecroutest",
        email: "rahmia@gmail.som",
        password: "123",
      },
      isForgetPassword: false,
      isKeepLogin: false,
    };
  },
  created() {
    this.$emit("TheLogin::loginResult", { loginResult: true });
  },
  mounted() {
    if (localStorage.getItem("isKeep") == true) {
      this.login();
    }
  },
  components: {
    PasswordRecovery,
  },
  methods: {
    keepLoginCheck(e) {
      this.isKeepLogin = !this.isKeepLogin;
    },
    forgetPassword: function () {
      this.isForgetPassword = !this.isForgetPassword;
    },
    login: function () {
      _login(this.model).then((response) => {
        if (response.data.success) {
          _authorize(response.data.data.token).then((res) => {
            if (res.data.success) {
              localStorage.setItem("user-token", res.data.data.token);
              var user = {
                tenantId: res.data.data.tenantId,
                userId: res.data.data.userId,
                email: res.data.data.email,
                authorities: res.data.data.authorities,
              };
              localStorage.setItem("user", JSON.stringify(user));
              localStorage.setItem("isKeep", this.isKeepLogin);
              this.$emit("TheLogin::loginResult", { loginResult: true });
              router.push("/");
              // Sayfaya giriş yapıldıgında refresh ediliyor
              this.$router.go(this.$router.currentRoute);
            }
          });
        }
      });
    },
    getEnvironmetMessage: function () {
      return AppConfiguration.Setting().environmentMessage;
    },
  },
};
</script>